import { render, staticRenderFns } from "./TemplateCharacterChoose.vue?vue&type=template&id=bd1788a8&scoped=true"
import script from "./TemplateCharacterChoose.vue?vue&type=script&lang=js"
export * from "./TemplateCharacterChoose.vue?vue&type=script&lang=js"
import style0 from "./TemplateCharacterChoose.vue?vue&type=style&index=0&id=bd1788a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1788a8",
  null
  
)

export default component.exports